import { EMBED_TRANSPORTS } from "@repo/embed";
import type { orpcClient } from "@shared/lib/orpc";
import { orpc } from "@shared/lib/orpc";
import { z } from "zod";

/** The SDKs an app code can be for: every transport except the web ones. */
const appTransportSchema = z
	.enum(EMBED_TRANSPORTS)
	.exclude(["iframe", "widget"]);
export const APP_TRANSPORTS = appTransportSchema.options;
export type AppTransport = z.infer<typeof appTransportSchema>;

/** Platform names for copy, and the "Code for" Select's items. */
export const APP_PLATFORM: Record<AppTransport, string> = {
	flutter: "Flutter",
	"react-native": "React Native",
	ios: "iOS",
	android: "Android",
};

/**
 * /embed-test: the retailer, store and mode to open; `launch=code` opens a test code at once,
 * `app` preselects the SDK an app code is for.
 */
export const embedTestSearchSchema = z.object({
	org: z.string().min(1).max(100).optional().catch(undefined),
	store: z.string().min(1).max(200).optional().catch(undefined),
	mode: z.enum(["iframe", "widget"]).optional().catch(undefined),
	launch: z.literal("code").optional().catch(undefined),
	app: appTransportSchema.optional().catch(undefined),
});
export type EmbedTestSearch = z.infer<typeof embedTestSearchSchema>;

export type EmbedTestTarget = Awaited<
	ReturnType<typeof orpcClient.embedSettings.test.targets>
>["organizations"][number];

export function embedTestTargetsQuery() {
	return orpc.embedSettings.test.targets.queryOptions();
}
